import React, { useEffect, useMemo, useState } from 'react'
import Layout from '../../components/Layout'
import PageHeader from '../../components/PageHeader';
import { CameraAltRounded, ClearRounded, DeviceThermostatRounded, QrCodeOutlined, QrCodeScanner } from '@mui/icons-material';
import { Alert, Button, Card, Col, Divider, Form, Input, InputNumber, Modal, QRCode, Radio, Row, Select, Space, Spin, Table, Tabs, Tag, message } from 'antd';
import { QrReader } from 'react-qr-reader';
import QRScanner from '../../components/QRScanner';
import { Content } from 'antd/es/layout/layout';
import useAxios from 'axios-hooks';
import { BASE_URL, formatDate, titleCase } from '../../utils/Common';
import { getAvailableLocations, getItems, getLocations } from '../../api/locationsApi';
import { stockIn, stockOut } from '../../api/inventoryApi';
import Title from 'antd/es/typography/Title';
const { Search } = Input;
const { Option } = Select;

export default function Find() {
  const [showSearchByQr, setShowSearchByQr] = useState(false);
  const [showStockIn, setShowStockIn] = useState(false);
  const [itemInfo, setItemInfo] = useState({});
  const [step, setStep] = useState(1);
  const [qrCode, setQRCode] = useState("");
  const [availableLocations, setAvailableLocations] = useState([]);
  const [checkingAvailableLocations, setCheckingAvailableLocations] = useState(false);
  const [qrExists, setQrExists] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [items, setItems] = useState([]);
  const [query, setQuery] = useState("");

  // const onSearch = (value) => console.log(value);
  const toaster = (type, content) => {
    messageApi.open({ type, content: titleCase(content) });
  };

  async function _getItems(values) {
    setLoading(true);
    const res = await getItems(values);
    if (res.data) {
      setItems(res.data);
    } else if (res.error) {
      setItems([]);
    }
    setLoading(false);
  }
  // CREATE STOCK OUT
  async function _stockOut(qr_code) {
    const res = await stockOut(qr_code);
    if (res.data) {
      console.log(res.data);
      toaster('success', res.data.message);
      window.location.reload();
    } else if (res.error) {
      console.log(res.error.data.messages.error_messages[0])
      toaster('error', res.error.data.messages.error_messages[0])
    }
  }

  useEffect(() => {
    document.title = "Find item"
  }, []);

  useMemo(() => {
    if (qrCode !== "") {
      setQuery("");
      _getItems({qr_code: qrCode});
    }
  }, [qrCode]);

  return (
    <Layout>
      <PageHeader title="Find item" noButton/>
      {contextHolder}

      <Row gutter={20}>
        <Col xs={24} md={12}>
          <Search
            placeholder="Search item name"
            value={query}
            onChange={(e)=>setQuery(e.target.value)}
            onSearch={(query)=>{ 
              setQRCode("");
              setQuery(query);
              if (query === ""){
                setItems([]);
              } else {
                _getItems({description_search: query});
              }
            }}
            allowClear
          />
          <QRScanner data={qrCode} setData={setQRCode} /> 
        </Col>
        <Col xs={24} md={12}>
          <Title level={5}>Search results:</Title>
          <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
            { loading ?  <Spin className='flex justify-center pt-10 pb-10'/>
              :
              <>
              { items.length > 0 ?
                <>
                {items?.map(item => {
                  return(
                    <Card 
                      key={item.id} 
                      size='small' 
                      title={item?.description} 
                      extra={
                       <Button danger disabled={item?.status !== "stockin"} onClick={()=>_stockOut(item.qr_code)}>Stock out</Button>
                      }
                    >
                      <Row>
                        <Col span={8}>
                          <p>Status:</p>
                          <p>Temperature:</p>
                          <p>Location:</p>
                          <p>Date in:</p>
                          <p>Added by:</p>
                          <p>Date out:</p>
                          <p>Stocked out by:</p>
                        </Col>
                        <Col span={16}>
                          <Tag bordered={false} color={item.status === "stockout" ? "red" : "cyan"}>
                            {item.status === "stockout" ? "Stock out" : "Stock in"}
                          </Tag>
                          <p className='text-slate-500'>{item?.temperature} Celsius</p>
                          <p className='text-slate-500'>{titleCase(item.location || "-")}</p>
                          <p className='text-slate-500'>{formatDate(item?.added_on)}</p>
                          <p className='text-slate-500'>{titleCase(item.added_by_name || "-")}</p>
                          <p className='text-slate-500'>{formatDate(item?.stockout_on)}</p>
                          <p className='text-slate-500'>{titleCase(item.stocked_out_by_name || "-")}</p>
                        </Col>
                      </Row>
                      
                    </Card>
                  )
                })}
                </>
                :
                <Alert message="No results. Please retry the QR code or use the search bar." type="error" showIcon />
              }
              </>
            }
          </Space>
        </Col>
      </Row>


    </Layout>
  )
}
